export enum AppAction {
  DELETE = 1,
  EDIT = 2,
  ADD = 0,
}

export interface IDropdownItem {
  lable: string;
  value: string | number;
}

export interface IMucDichSuDung {
  kyHieu: string;
  dienTich: number;
  heSo: number;
}

export interface IGeometry {
  name: string;
  area: number;
  geometry: string;
  color: string;
}

export interface IThongTinDuongChinh {
  tenDuong: string;
  tenDoanDuong?: string | null;
  vung1: number;
  vung2: number;
  vung3: number;
  vung4: number;
  vung5: number;
}

export interface IChiTietDinhGia {
  tenVung: string;
  dienTichVung: number;
  mdsd: string;
  dienTich: number;
  heSo: number;
  donGiaKV1: number;
  gia: number;
}

export interface IDinhGia {
  thuaLienKe?: string;
  tenDuong?: string | null;
  tenDoanDuong?: string | null;
  tenHem?: string | null;
  chieuDaiHem?: number;
  tenDuongGiao?: string | null;
  phuongPhapDinhGia: string;
  heSoTiepGiapDuong: number;
  tongGia: number;
  giaThiTruong: number;
  thongTinDuongChinh: IThongTinDuongChinh;
  chiTiets: IChiTietDinhGia[];
  geometries: IGeometry[];
  routeGeometries: string[];
}

export interface IThuaDat {
  soTo: string;
  soThua: string;
  dienTich: number;
  mucDichSuDungs: IMucDichSuDung[];
}

export interface IChiTietThuaDat {
  thuaDat: IThuaDat;
  dinhGias: IDinhGia[];
}

export interface IThuaDatIdentity {
  soTo: number;
  soThua: number;
  maHuyen: string;
  maXa: string;
}

export interface IThuaDatLienKe {
  soTo: number;
  soThua: number;
  maHuyen: string;
  maXa: string;
  mdsd: string;
  dienTich: number;
  geometry: string;
}

export interface IBangGiaDat {
  id: number;
  ma?: string;
  soQuyetDinh?: string;
  ngayBanHanh?: Date;
  coQuanBanHanh?: string;
  hieuLuc?: Date;
  hetHieuLuc?: Date;
  isDeleted: boolean;
  createdDate?: string;
  modifiedDate?: string;
  createdUser?: string;
  modifiedUser?: string;
  action: number;
  fileId?: string;
  laLichSu?: boolean;
  fileName?: string;
  uuid?: string;
}

export interface IKhungGiaDat {
  id: number;
  loaiKhuVucId?: number;
  khuVuc?: string;
  loaiDat?: string;
  vitri?: string;
  giaTien?: number;
  hieuLuc?: Date;
  hetHieuLuc?: Date;
  createdDate?: Date;
  modifiedDate?: Date;
  isDeleted?: boolean;
  createdUser?: string;
  modifiedUser?: string;
  loaiKhuVuc?: ILoaiKhuVuc;
  tenLoaiKhuVuc?: string;
  action?: number;
}

export interface ILoaiKhuVuc {
  id: number;
  ten: string;
  isDeleted: boolean;
}

export interface ILichSuGiaDat extends IDinhGia {
  soTo: number;
  soThua: number;
  modifiedDate?: Date;
}

export interface ILuuDinhGia extends IThuaDatIdentity, IDinhGia {}

export interface IFileInfo {
  expired: Date;
  id: string;
  name: string;
}

export interface ILoaiDat {
  maLoaiDat: string;
  tenLoaiDat: string;
}

export interface IKhuVuc {
  id: number;
  ten: string;
}

export interface IHeSoDieuChinh {
  mdsd: string;
  hieuLuc?: string;
  hetHieuLuc?: string;
  doThi?: {
    id?: number;
    vung1: number;
    vung2: number;
    vung3: number;
    vung4: number;
    vung5: number;
  };
  nongThon?: {
    id?: number;
    vung1: number;
    vung2: number;
    vung3: number;
    vung4: number;
    vung5: number;
  };
  isDeleted: boolean;
  createdDate?: string;
  modifiedDate?: string;
  createdUser?: string;
  modifiedUser?: string;
  action: number;
}
export interface IShapeFile {
  fileId: string;
  thuaDats: IThuaData[];
}
interface IThuaData {
  geometry: string;
  attributes: any;
}

export interface IKhuVucGiaDat {
  isDeleted?: boolean;
  createdDate?: Date;
  modifiedDate?: Date;
  createdUser?: string;
  modifiedUser?: string;
  uuid?: string;
  id: number;
  khuVuc?: string;
  maKhuVuc?: string;
  moTa?: string;
  hieuLuc?: Date;
  hetHieuLuc?: Date;
  laLichSu?: boolean;
  action: number;
}

export interface ITimTuyenDuong {
  tenDuong?: string; //tenDuong
  loaiGt?: string; //LOAI_GT
  diemDau?: string; //DIEMDAU
  diemCuoi?: string; //DIEMCUOI
  heSo?: number; //HeSo
  viTri_1?: number; //ViTri_1
  viTri_2?: number; //ViTri_2
  viTri_3?: number; //ViTri_3
  viTri_4?: number; //ViTri_4
  viTri_5?: number; //ViTri_5
  laTuyenDuongChinhTrongBangGiaDat?: number; //LaTuyenDuongChinhTrongBangGiaDat
  loaiDuong?: number; //LoaiDuong
  maDVHC?: string; //MaDVHC
  huyen?: string; //Huyen
  geo?: string;
}

export interface IDisplayGeo {
  color: string;
  geo: string;
}

export interface IRanhGioiDuong {
  loaiDuong?: number; //LoaiDuong
  huyen?: string; //Huyen
  geo?: string;
}
